<template>
  <div class="no-gutters mr-0 pr-0">
    <table class="table-bordered table-evaluation-info">
      <tr>
        <td>
          <div class="mt-3">
            <p class="font-weight-bold mb-0">{{$t('medium_grant_ev.diligence__info_risk_assesment')}}</p>
            <div class="mt-3">
              <table class="table-risk-assesment table-borderless">
                <tr>
                  <td><i v-if="totalScore <= 25" class="tim-icons icon-check-2 text-primary font-weight-bold"></i></td>
                  <td>{{$t('medium_grant_ev.diligence__info_risk_low')}}</td>
                </tr>
                <tr>
                  <td>
                    <i v-if="totalScore > 25 && totalScore <=40" class="tim-icons icon-check-2 text-primary font-weight-bold"></i>
                  </td>
                  <td>{{$t('medium_grant_ev.diligence__info_risk_medium')}}</td>
                </tr>
                <tr>
                  <td>
                    <i v-if="totalScore > 40" class="tim-icons icon-check-2 text-primary font-weight-bold"></i>
                  </td>
                  <td>{{$t('medium_grant_ev.diligence__info_risk_high')}}</td>
                </tr>
              </table>
            </div>
          </div>
        </td>
      </tr>
      <!--<tr v-if="!EvaluationForm.evaluation.admin_user_id && loggedUser.role === UserRoles.ADMIN">-->
        <!--<td>-->
          <!--<div class="mt-3">-->
            <!--<p class="font-weight-bold mb-0">{{$t('medium_grant_ev.general__info_admin_decission')}}</p>-->
            <!--<div class="mt-3">-->
              <!--<base-button-->
                <!--class="mb-1"-->
                <!--type="info"-->
                <!--size="sm"-->
                <!--@click="validateEvaluation"-->
              <!--&gt;-->
                <!--{{$t('medium_grant_ev.general__admin_validate_cta')}}-->
              <!--</base-button>-->
            <!--</div>-->
          <!--</div>-->
        <!--</td>-->
      <!--</tr>-->
      <tr>
        <td>
          <div class="mt-3">
            <p class="font-weight-bold mb-3">{{$t('medium_grant_ev.general__info_grid_by')}}</p>
            <div v-if="EvaluationForm.evaluation && EvaluationForm.evaluation.user">
              <div>{{EvaluationForm.evaluation.user.name}}</div>
              <small>{{EvaluationForm.evaluation.updated_at}}</small>
            </div>
            <div v-else>-</div>
          </div>
        </td>
      </tr>
      <!--<tr>-->
        <!--<td>-->
          <!--<div class="mt-3">-->
            <!--<p class="font-weight-bold mb-3">{{$t('medium_grant_ev.general__info_grid_validated_by')}}</p>-->
            <!--<div v-if="EvaluationForm.evaluation && EvaluationForm.evaluation.admin && EvaluationForm.evaluation.admin_validation_at">-->
              <!--<div>{{EvaluationForm.evaluation.admin.name}}</div>-->
              <!--<small>{{EvaluationForm.evaluation.admin_validation_at}}</small>-->
            <!--</div>-->
            <!--<div v-else>-</div>-->
          <!--</div>-->
        <!--</td>-->
      <!--</tr>-->
      <tr height="100">
        <td valign="center">
          <h1 class="m-0 p-0">TOTAL <span class="ml-4">{{totalScore}}</span></h1>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
  import {EvaluationForm, UserRoles} from "@/services";

  export default {
    data() {
      return {
        EvaluationForm,
        UserRoles,
        loggedUser: {}
      }
    },
    computed: {
      totalScore: function () {
        let total = 0;
        total += EvaluationForm.model.founding_docs || 0;
        total += EvaluationForm.model.governing_body || 0;
        total += EvaluationForm.model.is_governing_body || 0;
        total += EvaluationForm.model.legal || 0;
        total += EvaluationForm.model.audit || 0;
        total += EvaluationForm.model.financial_statements || 0;
        total += EvaluationForm.model.financial_principles || 0;
        total += EvaluationForm.model.financial_principles_ii || 0;
        total += EvaluationForm.model.policy || 0;
        total += EvaluationForm.model.debt || 0;
        total += EvaluationForm.model.insurance || 0;
        total += EvaluationForm.model.payment_signature || 0;
        total += EvaluationForm.model.funds_outside || 0;
        total += EvaluationForm.model.financial_capacity || 0;
        total += EvaluationForm.model.financial_capacity_i || 0;
        total += EvaluationForm.model.financial_capacity_iii || 0;
        total += EvaluationForm.model.management_i || 0;
        total += EvaluationForm.model.management_ii || 0;
        total += EvaluationForm.model.management_iii || 0;
        total += EvaluationForm.model.internal_a || 0;
        total += EvaluationForm.model.internal_e || 0;

        EvaluationForm.totalScore = total;

        return total;
      }
    },
    inject: ['validateEvaluation'],
    created() {

    },
    beforeMount() {
      let vm = this;
      setTimeout(function() {
        EvaluationForm.totalScore = vm.totalScore;
      }, 200);
    },
    mounted() {
      let vm = this;
      vm.loggedUser = vm.$store.getters['Auth/loggedUser'];
    }
  }
</script>
<style lang="scss" scoped>
  .table-risk-assesment td {
    padding-bottom: 0 !important;
    padding-left: 0 !important;
  }
</style>